import {getImageUrlFromName} from '../utils/UIHelper';
const Bowser = require('bowser');

// deprecated. TBD whether we need this method
async function getDownloadTime(image, quality, timeout) {
    const startTime = new Date().getTime();
    const request = new Request(getImageUrlFromName(image, quality));
    const controller = new AbortController();
    const signal = controller.signal;
    return new Promise((resolve, reject) => {
        let timeoutId;
        if (timeout) {
            const error = new Error(`Image of quality ${quality} timed out`);
            timeoutId = setTimeout(
                () => {
                    controller.abort();
                    reject(error);
                },
                timeout,
                error
            );
        }
        fetch(request, {signal}).then(() => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            resolve();
        }, reject);
    }).then(() => {
        const endTime = new Date().getTime();
        const time = endTime - startTime;
        return {
            time,
            quality
        };
    });
}

function isWebpSupported(useMediaGateway = false, overridePreviousValue = false) {
    // Media Gateway automatically retrieves webp format per browser accept headers
    if (useMediaGateway) {
        return false;
    }

    if (typeof isWebpSupported.isValidBrowser === 'undefined' || overridePreviousValue) {
        const browser = Bowser.getParser(window.navigator.userAgent);
        // verify User Agent supports webp format (according to https://developers.google.com/speed/webp/faq)
        // Refer Bowser: https://www.npmjs.com/package/bowser
        isWebpSupported.isValidBrowser = browser.satisfies({
            // per os
            iOS: {
                safari: '>=14'
            },
            // per platform (mobile, desktop or tablet)
            mobile: {
                chrome: '>=25'
            },
            desktop: {
                chrome: '>=17'
            },
            // or in general
            edge: '>=18',
            firefox: '>65',
            opera: '>11',
            android: '>=4'
        });
        // Additional code to handle open issue on bowser w.r.t IOS: https://github.com/lancedikson/bowser/issues/434
        if (browser.getOSName().toLowerCase() === 'ios' && browser.getOSVersion()) {
            const osMajorVersion = Number(String(browser.getOSVersion()).split('.')[0]);
            const browserName = browser.getBrowserName().toLowerCase();
            if ((browserName === 'chrome' || browserName === 'safari') && osMajorVersion >= 14) {
                isWebpSupported.isValidBrowser = true;
            } else {
                isWebpSupported.isValidBrowser = false;
            }
        }

        if (typeof isWebpSupported.isValidBrowser === 'undefined') {
            isWebpSupported.isValidBrowser = false;
        }
    }
    return isWebpSupported.isValidBrowser;
}

/**
 * units are Bytes/Second.
 * 0: q3, 1: q4, 2: q5, 3: q6, 4: q7
 * @type {Array}
 */

/*
    File size referred for quality 
    https://confluence.expedia.biz/pages/viewpage.action?spaceKey=virtualtours&title=Baseline+JPEG+vs+Progressive+JPEG+vs+WebP

    Calculator used to decide threshold.
    http://www.downloadcalculator.net/
    For approximations the nearest download speed less 250MS is considered for initial and less than a second is considered for progressive thresholds.
    Still the numbers are way larger than the priorly defined thresholds. Documenting prior values for reference.
    const progressiveQualityThresholds = [128000, 512000, 1540000, 5000000, 25600000];
 */
// Thresholds for < 250 MS downloads.
const initialQualityThresholds = [96000, 300000, 1000000, 3440000, 9400000];
// Thresholds for < 1000 MS downloads.
const progressiveQualityThresholds = [24000, 75000, 250000, 860000, 2350000];
/**
 * Given the time taken to download a number of bytes,
 * get a recommended image quality.
 * @param ms
 * @param bytes
 * @returns {number}
 */
function getRecommendedImageQuality(ms, bytes, isProgressiveLoad) {
    // The latency adjustment solves the problem in which low image qualities do not rebound
    // to higher qualities.  This is because the download time for a low quality image is
    // disproportionately affected by latency time when compared to a larger image.  The latency
    // adjustment improves this problem for low quality images, while not noticeably affecting
    // high quality images

    let latencyAdjustment = 100;
    let seconds = (ms - latencyAdjustment) / 1000;
    let bytesPerSecond = bytes / seconds;
    let qualityIndex = 4;

    let thresholdMultiplier = 0.8; // we use a .20 threshold to account for TCP/IP Overhead.
    // We expect Webp on an average to decrease image size by 30%. qualityThresholds redefined accrodingly.
    if (isWebpSupported()) thresholdMultiplier = thresholdMultiplier * 0.7;
    let qualityThresholds = initialQualityThresholds;

    // Our thresholds for progressive images are different.
    if (isProgressiveLoad) qualityThresholds = progressiveQualityThresholds;

    while (
        qualityThresholds[qualityIndex] * thresholdMultiplier >= bytesPerSecond &&
        qualityIndex !== 0
    ) {
        qualityIndex--;
    }
    return qualityIndex + 3;
}

export {getDownloadTime, getRecommendedImageQuality, isWebpSupported};
